export default {
  prefix: '',
  suffix: '',
  thousands: ',',
  decimal: '.',
  precision: 2
}



// WEBPACK FOOTER //
// ./src/utils/numeric/default.js